<template>
  <div class="confirm">
    <h1>Registrierung Bestätigen</h1>
    <p>
      Wir haben Ihnen eine Email mit dem Bestätigungscode geschickt. Dieser ist eine Stunde lang gültig. Bitte geben Sie
      diesen ein.
    </p>
    <v-form v-model="valid" ref="form" lazy-validation>
      <v-text-field
        outlined
        v-if="!show_user_not_found_message && !show_user_cannot_be_empty_message"
        v-model="username"
        :rules="emailRules"
        label="Email Adresse"
        placeholder="mustermann@unternehmen.de"
        required
        v-on:input="prop_email()"
      />
      <v-alert outlined dismissible v-model="show_user_cannot_be_empty_message" type="error">
        Email darf nicht leer sein.
      </v-alert>
      <v-alert outlined dismissible v-model="show_user_not_found_message" type="error">
        Ein Nutzer mit der Email {{ username }} wurde nicht gefunden.
      </v-alert>
      <v-text-field
        outlined
        v-model="code"
        v-if="!show_code_mismatch_message"
        :rules="codeRules"
        label="Code"
        placeholder="000000"
        required
      />
      <v-alert outlined dismissible v-model="show_code_mismatch_message" type="error">
        Der eingegebene Code stimmt nicht mit dem gesendeten Code überein
      </v-alert>
      <v-btn outlined block color="primary" :disabled="!valid" @click="submit">
        Registrierung abschließen
      </v-btn>
    </v-form>
    <v-btn text block color="secondary" @click="resend">Code erneut senden</v-btn>
  </div>
</template>

<script>
import { confirmSignUp, resendSignUp } from "./auth.js";
import { AmplifyEventBus } from "aws-amplify-vue";

export default {
  name: "SignUpConfirmView",
  props: {
    email: String,
  },
  mounted() {
    if (this.email) {
      this.username = this.email;
    }
  },
  data() {
    return {
      valid: false,
      username: null,
      code: null,
      resend_loading: false,
      show_user_not_found_message: false,
      show_user_cannot_be_empty_message: false,
      show_code_mismatch_message: false,
    };
  },
  computed: {
    emailRules() {
      return [
        (v) => !!v || "Email ist ein Pflichtfeld",
        (v) => /.+@.+\..+/.test(v) || "Feld muss eine Gültige Email enthalten",
      ];
    },
    codeRules() {
      return [(v) => !!v || "Code wird benötigt", (v) => (v && v.length === 6) || "Code besteht aus 6 Ziffern"];
    },
  },
  methods: {
    prop_email() {
      this.$root.$emit("email", this.username);
    },
    submit() {
      if (this.$refs.form.validate()) {
        //console.log(`CONFIRM username: ${this.username}, code: ${this.code}`);
        confirmSignUp(this.username, this.code).catch((res) => {
          if (res.code === "UserNotFoundException") {
            this.show_user_not_found_message = true;
          } else if (res.code === "CodeMismatchException") {
            this.show_code_mismatch_message = true;
          }
        });
      }
    },
    async resend() {
      //console.log(`RESEND username: ${this.username}`);
      this.resend_loading = true;
      resendSignUp(this.username).then((res) => {
        if (res === "SUCCESS") {
          // TODO: notify, message sent
        } else if (res === "Username cannot be empty") {
          this.show_user_cannot_be_empty_message = true;
        } else if (res.code === "UserNotFoundException") {
          this.show_user_not_found_message = true;
        }
      });
    },
  },
};
</script>
